import { RootState } from '@/App/store';

export const selectUserProfile = (state: RootState) => state.user;
